import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { is24HoursAfter } from 'src/app/shared/utils/dates';

import { NOTIFICATION_TYPES } from '../../../../constants';

type Props = {
	onDismiss?: () => void;
};

type UseAutoTaggedPetitionReturn = ModelHookResult<
	{ tags: string[]; numTags: number; anchorLink: string },
	{ handleEditTags: () => void; handleDismiss: () => void }
>;

export function useAutoTaggedPetition({ onDismiss }: Props): UseAutoTaggedPetitionReturn {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();

	const track = useTracking();

	const handleEditTags = useCallback(() => {
		void track('auto_tagged_petition_notification_cta_click', {
			notification: NOTIFICATION_TYPES.autoTaggedPetition,
		});
	}, [track]);

	const handleDismiss = useCallback(() => {
		onDismiss?.();
	}, [onDismiss]);

	const petitionTags = petition.tagsConnection.nodes;
	const tags = petitionTags
		.filter((node) => {
			if (!node.createdByModel) {
				return false;
			}

			if (!node.taggingCreatedAt) {
				return false;
			}

			return !is24HoursAfter(new Date(), new Date(node.taggingCreatedAt));
		})
		.map((node) => node.name);

	return {
		data: {
			tags,
			numTags: tags.length,
			anchorLink: `/p/${petition.slug}/edit`,
		},
		actions: { handleEditTags, handleDismiss },
	};
}
